import { faCircleInfo } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useId, useRef, useState } from 'react';
import PropTypes from 'prop-types'

export default function Tooltip({ children = null, label = "Additional" }) {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const popoverId = useId();
  const triggerRef = useRef(null);
  const focusFromPointerRef = useRef(false);
  const tooltipLabel = `${label} information`;

  useEffect(() => {
    if (!isTooltipVisible) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsTooltipVisible(false);
        triggerRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isTooltipVisible]);

  return (
    <div
      className="relative inline-block h-[1.378rem] w-[1.378rem] align-middle leading-none"
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setIsTooltipVisible(false);
        }
      }}
    >
      <button
        ref={triggerRef}
        type="button"
        onMouseDown={() => {
          if (document.activeElement !== triggerRef.current) {
            focusFromPointerRef.current = true;
          }
        }}
        onClick={() => {
          if (focusFromPointerRef.current) {
            focusFromPointerRef.current = false;
            setIsTooltipVisible(true);
            return;
          }
          setIsTooltipVisible((prev) => !prev);
        }}
        onFocus={() => setIsTooltipVisible(true)}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            setIsTooltipVisible(false);
          }
        }}
        aria-label={`${isTooltipVisible ? 'Hide' : 'Show'} ${tooltipLabel}`}
        aria-haspopup="dialog"
        aria-expanded={isTooltipVisible}
        aria-controls={popoverId}
        aria-describedby={isTooltipVisible ? popoverId : undefined}
        className="inline-flex h-[1.378rem] w-[1.378rem] items-center justify-center rounded-sm border-0 bg-transparent p-0 text-accent-cool"
      >
        <FontAwesomeIcon icon={faCircleInfo} className="cursor-pointer text-[1rem]" aria-hidden="true" />
      </button>
      {isTooltipVisible && (
        <div
          id={popoverId}
          role="dialog"
          aria-modal="false"
          aria-label={tooltipLabel}
          className="absolute left-0 bottom-full z-30 mb-2 border-solid border border-gray-light bg-white rounded p-2 text-sm shadow-lg transition-opacity duration-300"
          style={{ width: '20rem', maxWidth: 'calc(100vw - 2rem)' }}
        >
          {children}
        </div>
      )}
    </div>
  );

}

Tooltip.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
}

